import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const processingTimes = [
    {
        key: "administration-processingTime",
        path: `${APP_PREFIX_PATH}/processingTime`,
        component: React.lazy(() => import("views/app-views/processingTime")),
        meta: {
            permission: "LIST_PROCESSINGTIME"
        }
    },

    {
        key: "administration-processingTime-add",
        path: `${APP_PREFIX_PATH}/processingTime/add/`,
        component: React.lazy(() => import("views/app-views/processingTime/add")),
        meta: {
            permission: "ADD_PROCESSINGTIME"
        }
    },

    {
        key: "administration-processingTime-edit",
        path: `${APP_PREFIX_PATH}/processingTime/add/:codereference`,
        component: React.lazy(() => import("views/app-views/processingTime/edit")),
        meta: {
            permission: "EDIT_PROCESSINGTIME"
        }
    }
]



